import {createAction, props} from '@ngrx/store';
import {ViewConfigurationDTO} from '../../openapi/agrarinformationen-openapi';
import {MappedHttpErrorResponse} from '@adnova/jf-ng-components';


export class UserViewConfigActions {
  private static readonly prefix = '[User View Config] ';

  public static navigateAfterViewConfigHandled = createAction(
    this.prefix + 'Navigate after view config handled.',
    props<{restartApp?: boolean}>()
  );

  public static deleteConfig = createAction(
    this.prefix + 'delete config.'
  );

  public static readUserViewConfig = createAction(
    this.prefix + 'Read user view config.'
  );

  public static readUserViewConfigSuccess = createAction(
    this.prefix + 'Read user view config success.',
    props<{config: ViewConfigurationDTO}>()
  );

  public static readUserViewConfigFailure = createAction(
    this.prefix + 'Read user view config failed.',
    props<{error: MappedHttpErrorResponse}>()
  );

  // INFO: this action is used for both creating (for first time) as well as for updating the existing user view config.
  public static createUserViewConfig = createAction(
    this.prefix + 'Create user view config.',
    props<{ config: ViewConfigurationDTO, restartAppAfterwards?: boolean }>()
  );

  public static createUserViewConfigSuccess = createAction(
    this.prefix + 'Create user view config success.',
    props<{config: ViewConfigurationDTO}>()
  );

  public static createUserViewConfigFailure = createAction(
    this.prefix + 'Create user view config failed.',
    props<{error: MappedHttpErrorResponse}>()
  );

  public static updateUserViewConfig = createAction(
    this.prefix + 'Update user view config.',
    props<{config: ViewConfigurationDTO}>()
  );

  public static updateUserViewConfigSuccess = createAction(
    this.prefix + 'Update user view config success.',
    props<{config: ViewConfigurationDTO}>()
  );

  public static updateUserViewConfigFailure = createAction(
    this.prefix + 'Update user view config failed.',
    props<{error: MappedHttpErrorResponse}>()
  );
}
